/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_area_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I convert square units the same way as linear units (just square the factor)?`)
};

const es_uc_area_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo convertir unidades cuadradas de la misma manera que unidades lineales (solo elevar al cuadrado el factor)?`)
};

const de_uc_area_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich quadratische Einheiten genauso umrechnen wie lineare Einheiten (einfach den Faktor quadrieren)?`)
};

const nl_uc_area_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik eenheden in het vierkant converteren op dezelfde manier als lineaire eenheden (gewoon de factor kwadrateren)?`)
};

const fr_uc_area_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je convertir les unités carrées de la même manière que les unités linéaires (juste au carré le facteur) ?`)
};

const it_uc_area_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso convertire unità quadrate allo stesso modo delle unità lineari (solo quadra il fattore)?`)
};

const pt_br2_uc_area_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso converter unidades quadradas da mesma forma que unidades lineares (apenas quadrar o fator)?`)
};

const pt_uc_area_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso converter unidades quadradas da mesma forma que unidades lineares (apenas elevar ao quadrado o factor)?`)
};

const ja_uc_area_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`線形単位(係数を二乗するだけ)と同じ方法で平方単位を変換できますか?`)
};

const zh_uc_area_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_area_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_area_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_area_faq4_q", locale)
	if (locale === "en") return en_uc_area_faq4_q(inputs)
	if (locale === "es") return es_uc_area_faq4_q(inputs)
	if (locale === "de") return de_uc_area_faq4_q(inputs)
	if (locale === "nl") return nl_uc_area_faq4_q(inputs)
	if (locale === "fr") return fr_uc_area_faq4_q(inputs)
	if (locale === "it") return it_uc_area_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_area_faq4_q(inputs)
	if (locale === "pt") return pt_uc_area_faq4_q(inputs)
	if (locale === "ja") return ja_uc_area_faq4_q(inputs)
	return zh_uc_area_faq4_q(inputs)
};